import React from 'react';
import { AssemblyData } from './AssemblyGroups';
import { DatagridPropsCustom } from './interfaces/datagrid-props-custom';
import { Column } from 'material-table';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
type AssemblyGroupsTableProps = {
  defaultmessage: JSX.Element;
  columns: { columns: (Column<AssemblyData> & DatagridPropsCustom<AssemblyData>)[] };
  filteredData: AssemblyData[];
  pageSize?: number;
  disableVirtualization?: boolean;
  columnBuffer?: number;
};
export default function AssemblyGroupsTable(props: AssemblyGroupsTableProps) {
  const { columns, filteredData, defaultmessage, pageSize, disableVirtualization, columnBuffer } = props;

  const columnsDataGrid: GridColDef<AssemblyData>[] = columns.columns.map((value) => {
    return {
      headerName: value.title,
      field: value.field,
      width: value.width,
      disableColumnMenu: value.disableColumnMenu,
      filterable: value.filterable,
      sortComparator: value.sortComparator,
      valueGetter: value.valueGetter,
      renderCell: value.render
        ? (rowData) => {
            if (value.render) {
              return value.render(rowData.row, 'row');
            }
            return rowData.row;
          }
        : undefined,
    } as GridColDef<AssemblyData>;
  });
  if (disableVirtualization && columnBuffer) {
    return (
      <div style={{ width: '100%' }}>
        <DataGrid
          rows={filteredData}
          columns={columnsDataGrid}
          getRowId={(row) => row.blc as string}
          getRowHeight={() => 'auto'}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: pageSize ? pageSize : 10,
              },
            },
          }}
          disableColumnFilter={true}
          columnBuffer={columnBuffer ? columnBuffer : undefined}
          disableVirtualization={disableVirtualization}
          pageSizeOptions={pageSize ? [pageSize] : [10]}
          disableRowSelectionOnClick
        />
        {filteredData.length === 0 && <div>{defaultmessage}</div>}
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={filteredData}
        columns={columnsDataGrid}
        getRowId={(row) => row.blc as string}
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pageSize ? pageSize : 10,
            },
          },
        }}
        disableColumnFilter={true}
        pageSizeOptions={pageSize ? [pageSize] : [10]}
        disableRowSelectionOnClick
      />
      {filteredData.length === 0 && <div>{defaultmessage}</div>}
    </div>
  );
}
